// extracted by mini-css-extract-plugin
export default {"newProject_container":"Usuario_newProject_container__XdiTQ"};